import { InstrumentCreditCheckBulkUpsertLandingComponent } from './instrument-credit-check-bulk-upsert-landing.component';

export const containers: any[] = [InstrumentCreditCheckBulkUpsertLandingComponent];

export * from './instrument-credit-check-bulk-upsert-landing.component';